import { Instagram, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="relative bg-[#FFF8F0] border-t border-[#FF7A1A]/10 pt-14 pb-8" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row justify-between gap-10">
        <div className="max-w-sm">
          <img src="/holly-logo.png" alt="Holly's Juices" className="h-16 w-auto object-contain -ml-1" />
          <p className="mt-4 text-[#1A1A1A]/60 leading-relaxed">
            Small-batch, cold-pressed juices made fresh with real fruit and veg. Juices • Recipes • Wellness.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-10 sm:gap-16">
          <div>
            <h4 className="font-display font-bold text-[#1A1A1A] mb-3">Explore</h4>
            <ul className="space-y-2 text-[#1A1A1A]/60">
              <li><a href="#juices" className="hover:text-[#FF7A1A] transition-colors">Juices</a></li>
              <li><a href="#recipes" className="hover:text-[#FF7A1A] transition-colors">Recipes</a></li>
              <li><a href="#order" className="hover:text-[#FF7A1A] transition-colors">How to Order</a></li>
              <li><Link to="/admin" className="hover:text-[#FF7A1A] transition-colors" data-testid="footer-admin-link">Admin</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold text-[#1A1A1A] mb-3">Get in touch</h4>
            <ul className="space-y-3 text-[#1A1A1A]/60">
              <li>
                <a href="mailto:HollyJuicesLLC@gmail.com" className="flex items-center gap-2 hover:text-[#FF7A1A] transition-colors">
                  <Mail className="w-4 h-4" /> <span className="text-sm">HollyJuicesLLC@gmail.com</span>
                </a>
              </li>
              <li>
                <a href="tel:+18447814221" className="flex items-center gap-2 hover:text-[#FF7A1A] transition-colors" data-testid="footer-phone">
                  <Phone className="w-4 h-4" /> <span className="text-sm">844-781-4221</span>
                </a>
              </li>
              <li className="flex items-center gap-2">
                <span className="font-display font-extrabold text-[#7ED321]">$</span>
                <span className="text-sm font-semibold">HollyJuices</span>
              </li>
              <li>
                <a href="#" className="inline-flex items-center gap-2 hover:text-[#FF3D68] transition-colors" data-testid="footer-instagram">
                  <Instagram className="w-4 h-4" /> <span className="text-sm">@HOLLYJUICES</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-[#1A1A1A]/10 flex flex-col sm:flex-row justify-between items-center gap-3">
        <p className="text-sm text-[#1A1A1A]/40">© {new Date().getFullYear()} Holly's Juices LLC. All rights reserved.</p>
        <p className="text-sm text-[#1A1A1A]/40">Made fresh with 🍊 &amp; 🥬</p>
      </div>
    </div>
  </footer>
);

export default Footer;
